<template>
  <div class="containers">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('notifications.many'), name: 'all_notifications' },
            { text: $t('notifications.editTopic') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content">
      <div class="entries-wrap">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('notifications.createTopic') }}</h3>
          </header>
          <div class="content-body">
            <Form v-model="notification_topic" @submit="updateTopic" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/notifications/topics/Form.vue'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'

import notificationTopicsApi from '@/api/notificationTopics'

export default {
  name: 'new_notification_topic',
  inject: ['companyUser'],
  components: { BreadCrumbs, SectionHeader, Form },
  data() {
    return {
      notification_topic: {},
    }
  },
  methods: {
    updateTopic: async function (topic) {
      const updatedNotificationTopic = await notificationTopicsApi.update(topic.uuid, topic)

      if (updatedNotificationTopic) {
        await this.$router.push('/notifications')
      }
    },
  },
  async mounted() {
    const topic = await notificationTopicsApi.get(this.$route.params.uuid)

    if (topic.type == 'fill_level') {
      topic.project_uuid = topic.project.uuid
      delete topic.project
    }

    topic.channel_uuids = topic.channels.map(function (channel) {
      return channel.uuid
    })
    delete topic.channels

    this.notification_topic = topic
  },
}
</script>
